module.exports = __webpack_public_path__ + "static/bg-hero-13a8f214be926d2a7d8342e5c1d0ca05.svg";